<template>
  <v-container fluid grid-list-xl pt-0>
    <v-layout wrap>
      <v-flex xs12>
        <material-card
          :title="'週 Performance 生產概況 (' + summaryWeeksRange + ')'"
          class="card-shrink card-padding v-card__first"
          color="general"
        >
          <div class="card-memo-1 text-white">
            <v-icon class="text-warning">mdi-checkbox-blank</v-icon>
            黃字代表不良率大於1%
          </div>
          <div class="card-memo-2 text-white">
            <v-icon class="text-danger">mdi-checkbox-blank</v-icon>
            紅字代表不良率大於3%
          </div>
          <v-form>
            <v-container py-0 class="mw-100">
              <v-layout wrap>
                <v-flex xs12 lg2>
                  <v-autocomplete
                    v-model="summaryWeeks"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="weekOptions"
                    label="時間"
                    outlined
                  />
                </v-flex>
                <v-flex xs12 sm6 lg2>
                  <v-autocomplete
                    v-model="summaryVendor"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryVendorMenu"
                    label="供應商（選填）"
                    clearable
                    outlined
                  />
                </v-flex>
                <v-flex xs12 sm6 lg2>
                  <v-autocomplete
                    v-model="summaryProcessType"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryProcessTypeMenu"
                    label="製程別"
                    :rules="[v => !!v || '請選擇製程別']"
                    outlined
                  />
                </v-flex>
                <v-flex xs12 sm6 lg3>
                  <v-autocomplete
                    v-model="summaryAsusDeviceIsn"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryAsusDeviceIsnMenu"
                    label="料號（選填）"
                    clearable
                    outlined
                  />
                </v-flex>
                <v-flex xs12 lg3 text-xs-right>
                  <v-btn class="mx-0 font-weight-light" color="general" @click="doSubmit()">
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>查詢
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>

        <material-card>
          <v-data-table
            :headers="headers"
            :items="responseTable"
            :pagination.sync="pagination"
            multi-sort
            hide-actions
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="subheading font-weight-light text-general text--darken-3" v-text="header.text"/>
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.date }}</td>
              <td>{{ item.modelName }}</td>
              <td>{{ item.deviceIsn }}</td>
              <td>{{ item.processType }}</td>
              <td class="text-xs-right">{{ item.productionQty }}</td>
              <td class="text-xs-right">{{ item.failQty }}</td>
              <td class="text-xs-right">
                <v-chip :class="item.warningColor" small>{{ (item.failRate*100).toFixed(1) }}%</v-chip>
              </td>
              <td>{{ item.vendor }}</td>
              <td>
                <router-link
                  :to="'/ctqThermalPerformance/testDataStatistc?deviceIsn='+item.deviceIsn+'&modelname='+item.modelName+'&date='+item.date+'&vendorpk='+item.vendorPk+'&vendor='+item.vendor+'&processType='+item.processType"
                  target="_blank"
                >
                  <v-btn class="mx-0 font-weight-light small" color="primary">
                    <v-icon class="mr-2">mdi-chart-bar</v-icon>當日統計
                  </v-btn>
                </router-link>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { getWeekSummary } from './mockData'
import searchCascadeMixin from './searchCascadeMixin'

export default {
  name: 'CTQThermalPerformanceWeekly',
  mixins: [searchCascadeMixin],
  data () {
    return {
      summaryWeeks: '2026-W32',
      summaryWeeksRange: '',
      weekOptions: [
        { text: '2026-W31 (07/27~08/02)', value: '2026-W31' },
        { text: '2026-W32 (08/03~08/09)', value: '2026-W32' },
        { text: '2026-W33 (08/10~08/16)', value: '2026-W33' },
        { text: '2026-W34 (08/17~08/23)', value: '2026-W34' }
      ],
      weekRangeMap: {
        '2026-W31': ['2026-07-27', '2026-08-02'],
        '2026-W32': ['2026-08-03', '2026-08-09'],
        '2026-W33': ['2026-08-10', '2026-08-16'],
        '2026-W34': ['2026-08-17', '2026-08-23']
      },
      responseTable: [],
      pagination: { rowsPerPage: -1, sortBy: 'date', descending: false },
      headers: [
        { text: '日期', value: 'date' },
        { text: '案名', value: 'modelName' },
        { text: '料號', value: 'deviceIsn' },
        { text: '製程別', value: 'processType' },
        { text: '生產數量', value: 'productionQty', align: 'right' },
        { text: '不良數量', value: 'failQty', align: 'right' },
        { text: '不良率', value: 'failRate', align: 'right' },
        { text: '供應商', value: 'vendor' },
        { text: '操作', value: '' }
      ]
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink'])
  },
  mounted () {
    if (this.$route.params.searchDate) {
      const p = String(this.$route.params.searchDate)
      // YYYYWW -> 2026-W32
      if (p.length === 6) {
        this.summaryWeeks = p.substr(0, 4) + '-W' + p.substr(4, 2)
      }
    }
    this.doSubmit()
  },
  methods: {
    doSubmit () {
      if (!this.summaryProcessType) return
      const range = this.weekRangeMap[this.summaryWeeks] || ['2026-08-03', '2026-08-09']
      this.summaryWeeksRange = range[0] + ' ~ ' + range[1]
      this.responseTable = getWeekSummary({
        startDate: range[0],
        endDate: range[1],
        vendor: this.summaryVendor,
        deviceIsn: this.summaryAsusDeviceIsn,
        processType: this.summaryProcessType
      })
    }
  }
}
</script>
